import { render, staticRenderFns } from "./ConsumableType.vue?vue&type=template&id=5d55c514&scoped=true&"
import script from "./ConsumableType.vue?vue&type=script&lang=js&"
export * from "./ConsumableType.vue?vue&type=script&lang=js&"
import style0 from "./ConsumableType.vue?vue&type=style&index=0&id=5d55c514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55c514",
  null
  
)

export default component.exports